
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { toast } from 'sonner';

interface AssignRoleParams {
    user_id: string;
    role: string;
    work_type?: string;
    managerID?: string;
    status?: string;
    assigneuser?: string[];
}

export function useAssignRole() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (params: AssignRoleParams) => {
            const response = await api.post('/api/v1/tapanel/assign-role', params);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['admin', 'all-users'] });
            toast.success('Role assigned successfully!');
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message || 'Failed to assign role');
        },
    });
}
